// Chakra imports
import { Flex } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Map from "./components/Map";
import axios from "axios";
import { getToken } from "utils/auth";
import config from "config";

function MapData() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchIndividuals = async () => {
      const token = getToken();
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      try {
        const response = await axios.get(`${config.API_URL}/stats/map`, { headers });
        setData(response.data || null);
      } catch (error) {
        console.error("Error fetching map distribution dataset:", error);
      }
    };

    fetchIndividuals();
  }, []);

  return (
    <Flex direction='column' pt={{ base: "62px", md: "75px", xl: "88px" }}>
      <Map
        title={"Map"}
        data={data}
      />
    </Flex>
  );
}

export default MapData;
